import React from 'react';
import { Input } from 'antd';
import { InputProps } from 'antd/lib/input';
import { FormikValues, useField } from 'formik';
import { useFormikFormContext } from '../FormikFormContext';
import { IExtraInputProps, useInputProps } from '../hooks/useInputProps';

export interface TextInputProps<T extends FormikValues>
  extends Omit<InputProps, 'name'>,
    IExtraInputProps {
  name: keyof T & string;
}

/**
 * Campo per input testuale.
 */
export function TextInput<T extends FormikValues>(props: TextInputProps<T>) {
  const { name, extraOptions, ...otherProps } = props;
  const [field, meta] = useField(name);
  const inputProps = useInputProps(props);

  return <Input {...field} {...otherProps} {...inputProps} />;
}
